var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meetingDocuments.length)?_c('div',{staticClass:"meeting-documents mb-xxl"},[_c('h4',{staticClass:"h4 mb-xl"},[_vm._v("Meeting Documents")]),_vm._v(" "),_vm._l((_vm.meetingDocuments),function(item){return _c('meeting-item',{key:item.id,attrs:{"title":item.title,"documents":item.documents,"links":item.links}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }